module.exports = __webpack_public_path__ + "img/ZWF_Kacper_Julia.77315a28.jpg";